export enum EButtonData {
    available = "1",
    connected = "2"
}